import React, { useState, useEffect } from "react";
import Styled from "styled-components";
import Pdf from "../Images/pdf.png";
import axios from "axios";
import { Link } from "react-router-dom";

function BBA() {
  const [response, setresponse] = useState([]);
  const API = process.env.REACT_APP_API;

  useEffect(() => {
    window.scroll(0, 0);
    axios
      .get(`${API}/course/cpe-rpe/view`)
      .then((res) => {
        console.log(res.data.data);
        setresponse(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <div>
      <Container>
        <Box>
          <h1> Course work programs for M. Phil/ Ph. D scholars (CPE- RPE)</h1>
          <Bottom>
            <p className="top">
              The Centre, being an Inter University Centre of Excellence is
              vested with the responsibility of providing the mandatory two
              credit course work program on "Research and Publication Ethics" to
              research scholars pursuing their course work in Ph. D/M. Phil
              (irrespective of any discipline) in the State as well as the whole
              of the country and abroad.{" "}
            </p>
          
         
       
          
            <p className="disclaimer">
              ** Subject to changes made to these regulations from time to time
              by the University.
            </p>
            {response.map((res)=>(
            <a href={res.file} target="_blank">

              <img src={Pdf} alt="pdf" />
            <h3>{res.file_name}</h3>

            </a>

            ))}
            <Link to="/phdarchive">
              <p className="end">Click here to view archived files</p>
            </Link>

          </Bottom>
        </Box>
      </Container>
    </div>
  );
}

export default BBA;

const H6 = Styled.h6`
font-family: PT Serif;
font-style: normal;
font-weight: bold;
font-size: 20px;
line-height: 24px;
margin:0px;
color: #000000;
@media screen and (max-width:860px){
    font-size:18px;
 }
 @media screen and (max-width:600px){
    font-size:16px;
 }
`;
const Div = Styled.div`
display:flex;
   p.number{
       
        font-family: PT Serif;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 24px;
        color: #000000;
        width:20%;
   }
   p.colon{
    width:8%;
  }
  p.medium{
    font-size: 20px;
    line-height: 24px;
      width:85%;
      text-align:justify;
      font-family: PT Serif;
  }
  @media screen and (max-width:1400px){
     p.number{
         width: 24%;
     }
     p.medium{
     }
  }
  @media screen and (max-width:1200px){
    p.number{
        width: 26%;
    }
 }
 @media screen and (max-width:1124px){
    p.number{
        width: 30%;
    }
 }
 @media screen and (max-width:1024px){
    p.number{
        width: 32%;
    }
 }
 @media (max-width:860px){
    p.number{
        font-size:18px;
    }
    p.medium{
        font-size:18px;
    }
}
@media (max-width:640px){
  p.number{
      font-size:16px;
  }
  p.medium{
      font-size:18px;
  }  
}
@media (max-width:600px){
  p.number{
      font-size:15px;
  }
  p.medium{
      font-size:16px;
  }  
}
@media (max-width:540px){
  p.number{
      width:35%;
  }
  p.medium{
     width:50%;
  }  
  p.colon{
      width:10%;
  }
}
@media (max-width:540px){
  p.number{
      width:35%;
  }
  p.medium{
     width:50%;
  }  
  p.colon{
      width:10%;
  }
}
@media (max-width:410px){
  p.number{
      width:40%;
  }
  p.medium{
     width:40%;
  }  
  p.colon{
      width:12%;
  }
}
`;

const Container = Styled.div`
display:flex;
background: #FAFAFA;
align-items:center;`;

const Box = Styled.div`
width:85%;
margin:50px auto;


p.top{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
}
p.disclaimer{
    font-family: PT Serif;
    font-style: italic;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    text-align:justify;
    color: #000000;
  }
h1{
    font-family: Oswald;
    font-style: normal;
    font-weight:500;
    font-size: 32px;
    line-height: 36px;
    color: #E01E38;

    
}
@media (max-width:860px){
    h1{
        font-size: 28px;
    }
    p.top{
        font-size: 18px; 
    }
   
    p.disclaimer{
        font-size: 18px;
    }
}
@media (max-width:640px){
    h1{
        font-size: 26px;
       
    }
}
@media (max-width:600px){
    margin-top:30px;
    margin-bottom:30px;
    h1{
        font-size: 26px;
        
    }
    p.top{
        font-size: 16px; 
    }
    p.disclaimer{
        font-size: 16px;
    }`;
const Bottom = Styled.div`
padding:20px 40px ;
background: #fff;
box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
img{
    width:70px;
    height:75px;
}
p.end{
    text-align:justify;
    font-family: PT Serif;
    font-size: 20px;
    line-height: 24px;
    text-decoration:none;
    color : #000;
}
@media (max-width:860px){
    padding:20px 30px 40px 30px;   
}
@media (max-width:860px){
    p.end{
        font-size: 18px;
    }
}
@media (max-width:640px){
    p.end{
        font-size: 16px;
    }
}
`;
